module.exports = __webpack_public_path__ + "static/img/logoXY.29851d99.png";